import { CampaignActionsListController } from './campaign-actions-list.controller'

function campaignActionsList () {
  return {
    scope: {
      campaign: '=',
      onActionSelect: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-actions-list/campaign-actions-list.html?$$REVISION$$',
    controller: CampaignActionsListController
  }
}

export { campaignActionsList }
